import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';
// 客户投标网站账号管理-分页查询-ylx
export const getBiddingAccountList = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/page',
        method: 'post',
        data
    });
};

export const biddingAccountImportApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/import',
        method: 'post',
        data
    });
};

export const biddingAccountDownloadApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/download/template',
        method: 'post',
        data,
        responseType: 'blob'
    });
};
// 客户投标网站账号管理-重启-ylx
export const biddingAccountEnableApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/restart',
        method: 'post',
        data
    });
};
// 客户投标网站账号管理-废弃-ylx
export const biddingAccountDiscardApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/discarded',
        method: 'post',
        data
    });
};
// 客户投标网站账号管理 - 查询变更日志记录 -ylx
export const getBiddingAccountRecordApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/record',
        method: 'post',
        data
    });
};
// 客户投标网站账号管理-新建-ylx
export const biddingAccountSaveApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/update',
        method: 'post',
        data
    });
};
// 户投标网站账号管理-批量新建-ylx
export const biddingAccountBatchSaveApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/batch/save',
        method: 'post',
        data
    });
};
// 客户投标网站账号管理-查询详情-ylx
export const getBiddingAccountDetailApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/detail',
        method: 'post',
        data
    });
};
// 客户投标网站账号管理-导出-ylx
export const biddingAccountExportApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/export',
        method: 'post',
        data
    });
};
// 客户投标网站账号管理-权限查询-ylx
export const getBiddingAccountPermissionApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/tenderer/account/role',
        method: 'post',
        data
    });
};
